// extracted by mini-css-extract-plugin
export default {"btn":"PackageCategoryLabel_btn__E5uE2","badge":"PackageCategoryLabel_badge__5dxqy","bg":"PackageCategoryLabel_bg__Ph8gy"};